module.exports = __webpack_public_path__ + "static/img/default-picture.9a215207.png";